module.exports = __webpack_public_path__ + "static/img/26840.b838434.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/productCenter/ddjy/26840.png
// module id = Wlg1
// module chunks = 0